import { UserMasterReducer } from '@/utils/interfaces';
import { createSlice } from '@reduxjs/toolkit';



export const initialUserState: UserMasterReducer = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    dob: '',
    gender: '',
    relation: '',
    code: '',
    age: '',
    bloodGroup: '',
    cityUuid: '',
    email: '',
    numberOfAccessions: '',
    productDetailDtoList: '',
    title: '',
    membersList: [],
    availablePoints: null
}

const userReducer = createSlice({
    name: 'userDataReducer',
    initialState: initialUserState,
    reducers: {
        updateUserProfile: (state, action) => {
            state.firstName = action.payload.firstName
            state.lastName = action.payload.lastName
            state.phoneNumber = action.payload.phoneNumber
            state.dob = action.payload.dob
            state.gender = action.payload.gender
            state.relation = action.payload.relation
            state.code = action.payload.code
            state.age = action.payload.age
            state.bloodGroup = action.payload.bloodGroup
            state.cityUuid = action.payload.cityUuid
            state.email = action.payload.email
            state.numberOfAccessions = action.payload.numberOfAccessions
            state.productDetailDtoList = action.payload.productDetailDtoList
            state.title = action.payload.title
            state.membersList = action.payload.membersList
        },
        resetUserProfile: () => {
            return initialUserState
        },
        updateAvailablePoints: (state, action) => {
            state.availablePoints = action.payload
        }

    },
});

export const { updateUserProfile, resetUserProfile, updateAvailablePoints } = userReducer.actions;

export default userReducer.reducer;
